// Frontend game registry — SINGLE SOURCE OF TRUTH for which games the
// app renders.
//
// Adding a new game = (1) drop a folder under src/games/<id>/ with a
// Page.tsx and an index.ts that default-exports a GameModule (see
// ./types.ts), and (2) add one import line here + push into GAMES.
//
// App.tsx builds its per-game routes from this array, and the home
// dashboard's GameGrid renders its tiles from it. No other file needs
// editing when a new game is added.
import type { GameModule } from './types';
import ludo         from './ludo';
import xo           from './xo';
import rummy        from './rummy';
import chess        from './chess';
import carrom       from './carrom';
import snakeLadder  from './snake_ladder';
import plinko       from './plinko';
import lucky7       from './lucky7';
import thimbles     from './thimbles';
import cricket      from './cricket';
import football     from './football';
import tennis       from './tennis';
import roulette     from './roulette';
import gemsMine     from './gems_mine';
import aviator      from './aviator';
import andarBahar   from './andar_bahar';
import teenPatti    from './teen_patti';
import casino       from './casino';
import matkaKing    from './matka_king';

export const GAMES: readonly GameModule[] = Object.freeze([ludo, xo, rummy, chess, carrom, snakeLadder, plinko, lucky7, thimbles, cricket, football, tennis, roulette, gemsMine, aviator, andarBahar, teenPatti, casino, matkaKing]);

export function getGame(id: string): GameModule | undefined {
  return GAMES.find((g) => g.id === id);
}
